// extracted by css-extract-rspack-plugin
export default {"drawer":"src-modules-desktop-components-DevDrawer-DevDrawer-module__drawer-g6bNv_","handle":"src-modules-desktop-components-DevDrawer-DevDrawer-module__handle-My8hLx","tool":"src-modules-desktop-components-DevDrawer-DevDrawer-module__tool-qIrlge","closeButton":"src-modules-desktop-components-DevDrawer-DevDrawer-module__closeButton-JV8Usu","toolDot":"src-modules-desktop-components-DevDrawer-DevDrawer-module__toolDot-VOwFnd"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"drawer\":\"src-modules-desktop-components-DevDrawer-DevDrawer-module__drawer-g6bNv_\",\"handle\":\"src-modules-desktop-components-DevDrawer-DevDrawer-module__handle-My8hLx\",\"tool\":\"src-modules-desktop-components-DevDrawer-DevDrawer-module__tool-qIrlge\",\"closeButton\":\"src-modules-desktop-components-DevDrawer-DevDrawer-module__closeButton-JV8Usu\",\"toolDot\":\"src-modules-desktop-components-DevDrawer-DevDrawer-module__toolDot-VOwFnd\"}";
        // 1793875572042
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  